import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskAnimalObservationIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M22.8184 12.0004C22.8184 12.0004 18.363 5 11.9998 5C5.57209 5 1.18118 12.0004 1.18118 12.0004C1.18118 12.0004 4.36341 19.0008 11.9998 19.0008C19.5729 19.0008 22.8184 12.0004 22.8184 12.0004ZM16.4539 12.0004C16.4539 14.4822 14.4816 16.4545 11.9998 16.4545C9.51795 16.4545 7.54563 14.4822 7.54563 12.0004C7.54563 9.51859 9.51795 7.54627 11.9998 7.54627C14.4816 7.54627 16.4539 9.51859 16.4539 12.0004ZM11.9998 13.9094C10.945 13.9094 10.0907 13.0551 10.0907 12.0004C10.0907 10.9456 10.945 10.0913 11.9998 10.0913C13.0545 10.0913 13.9088 10.9456 13.9088 12.0004C13.9088 13.0551 13.0545 13.9094 11.9998 13.9094Z'
        />
    ),
})

TaskAnimalObservationIcon.displayName = 'TaskAnimalObservationIcon'
